import $ from 'jquery';
import ProductFilterList from '../components/product-filter-list';
import inViewport from '../../../../drager/assets/scripts/util/in-viewport';

export default {
  init() {
    const filterList = new ProductFilterList();
    this.$container = $('.product-filter-list');
    this.$toggle = $('.filter-toggle');
    this.addEvents();
    this.modifyDOM();
  },

  addEvents() {
    $(window).on('scroll', this.scroll.bind(this));
    this.$toggle.on('click', this.scrollTo.bind(this));
  },

  modifyDOM() {
  },

  scrollTo() {
    $([document.documentElement, document.body]).animate({
      scrollTop: this.$container.offset().top,
    }, 1000);
  },

  scroll() {
    if (!this.$container) {
      return;
    }

    if (inViewport(this.$container, 300)) {
      this.$toggle.show();
    } else {
      this.$toggle.hide();
    }
  },
};
